module.exports = __webpack_public_path__ + "32004f497cf7ddeab5594563affe5b7b.svg";